/* src/app/shared-module/components/create-activity/create-activity.component.scss */
.activity-modal-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px 16px;
  background:
    linear-gradient(
      145deg,
      var(--ion-color-secondary-shade) 0%,
      #2d4f96 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
}
.activity-header-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.22);
  flex-shrink: 0;
}
.activity-header-icon-box ion-icon {
  font-size: 22px;
  color: #fff;
}
.activity-header-copy {
  flex: 1;
  min-width: 0;
}
.activity-header-kicker {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
}
.activity-header-title {
  margin: 3px 0 0;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  line-height: normal;
}
.activity-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.14);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.2s ease;
}
.activity-close-btn ion-icon {
  font-size: 22px;
  color: #fff;
}
.activity-close-btn:hover,
.activity-close-btn:focus {
  background: rgba(255, 255, 255, 0.26);
  outline: none;
}
.activity-modal-body {
  padding: 16px;
  background:
    linear-gradient(
      180deg,
      var(--ion-color-secondary) 0%,
      var(--ion-color-primary-tint) 100%);
}
.activity-field-card {
  margin: 0 0 14px;
  border-radius: 20px;
  border: 1px solid var(--ion-color-light-tint);
  background: var(--ion-color-secondary);
  box-shadow: 0 8px 20px var(--ion-color-secondary-contrast);
}
.activity-field-card ion-card-content {
  padding: 16px !important;
}
.field-row-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}
.field-row-header:first-child {
  margin-top: 0;
}
.field-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-light-tint);
  flex-shrink: 0;
}
.field-icon-box ion-icon {
  font-size: 17px;
  color: var(--ion-color-secondary-shade);
}
.field-label {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  color: var(--ion-color-secondary-shade);
}
.field-quick-link {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 11px;
  border-radius: 20px;
  border: 1px solid var(--ion-color-primary);
  background: transparent;
  color: var(--ion-color-primary);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.field-quick-link ion-icon {
  font-size: 15px;
}
.field-quick-link:hover {
  background: var(--ion-color-primary-tint);
}
mat-form-field {
  width: 100%;
  margin-bottom: 4px;
}
.activity-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding-top: 4px;
  flex-wrap: wrap;
}
.custom-list-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 15px;
  border-radius: 20px;
  border: 1px solid var(--ion-color-secondary-shade);
  background: transparent;
  color: var(--ion-color-secondary-shade);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.custom-list-pill ion-icon {
  font-size: 16px;
}
.custom-list-pill:hover {
  background: var(--ion-color-secondary-shade);
  color: #fff;
}
.footer-btn-group {
  display: flex;
  gap: 8px;
  align-items: center;
}
.btn-cancel {
  --background: transparent;
  --border-color: var(--ion-color-secondary-shade);
  --color: var(--ion-color-secondary-shade);
  --box-shadow: none;
  --border-radius: 12px;
  --border-width: 1px;
  --border-style: solid;
}
.btn-submit {
  --background: var(--ion-color-secondary-shade);
  --color: #fff;
  --box-shadow: 0 6px 16px var(--ion-color-secondary-contrast);
  --border-radius: 12px;
}
/*# sourceMappingURL=create-activity.component.css.map */
